export type BaseSimulationType = 'Users' | 'Groups' | 'Access' | 'none';

export abstract class SimulationBaseEntity {
	protected abstract simType: BaseSimulationType;

	public getType(): BaseSimulationType {
		return this.simType;
	}
}
